import type { ConfigurableProperty, DigitalTwinTranslations } from 'api/digitalTwin/digitalTwin.api'
import type { AppliedSettingSeries } from 'helpers/appliedSettingValues.helper/appliedSettingValues.types'
import { getSelectedProperties } from 'helpers/appliedSettingValues.helper/propertySelection.helper'
import { selectSeries } from 'helpers/appliedSettingValues.helper/seriesSelection.helper'
import { getActiveTags, getTagsByTopLevelTag } from 'hooks/filterHooks/filterHooks'
import { getPrettyName } from 'views/DigitalTwinSettingsView/DigitalTwinSettingsView.helper'

type SavedFilterSeriesScope = {
  availableFiltersSubset: string[][]
  allProperties: ConfigurableProperty[]
  priorityLevels: number[]
  catalogue: AppliedSettingSeries[]
}

/** How many series the table would show if the saved filter were applied. */
export function countSavedFilterSeries(
  urlFilters: Record<string, string[]>,
  { availableFiltersSubset, allProperties, priorityLevels, catalogue }: SavedFilterSeriesScope
): number {
  const routeTags = [...new Set(availableFiltersSubset.flat())]
  const activeTags = getActiveTags(getTagsByTopLevelTag(routeTags), urlFilters)
  const selectedProperties = getSelectedProperties(allProperties, priorityLevels, [...activeTags])

  return selectSeries(catalogue, selectedProperties).length
}

/** The filter as the dropdowns name it, one `Category: chosen options` part per category. */
export function describeSavedFilter(
  urlFilters: Record<string, string[]>,
  translations: DigitalTwinTranslations
): string[] {
  return Object.entries(urlFilters)
    .filter(([, values]) => values.length > 0)
    .map(
      ([category, values]) =>
        `${getPrettyName(category, translations)}: ${values.map((value) => getPrettyName(value, translations)).join(', ')}`
    )
}
